import React, { forwardRef }    from 'react';
import PropTypes                from 'prop-types';

import Carousel                 from '../../../../components/Carousel';
import styles                   from './StepsBlock.styl';

function StepsBlock(props, ref) {

    // const {} = useMessage();

    return  (
        <section
            className={styles.StepsBlock}
            ref = {ref}
        >
            <div className={styles.blockName}>
                <span className={styles.dot} />
                5 Easy Steps
            </div>
            <h2 className={styles.blockTitle}>
                Just 10 minutes to get started with ROIMAX!
            </h2>
            <div className={styles.carousel}>
                <Carousel />
            </div>
        </section>
    );
}

StepsBlock.propTypes = {
    className : PropTypes.string
};

StepsBlock.defaultProps = {
    className : ''
};

export default forwardRef(StepsBlock);
